module.exports = __webpack_public_path__ + "static/media/signup-image-5.7ea2a6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/signup-image-5.jpg
// module id = 959
// module chunks = 0